var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseFilterIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#FF1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81612 4.24469C10.109 3.95179 10.109 3.47692 9.81612 3.18403C9.52323 2.89113 9.04836 2.89113 8.75546 3.18403L6.50007 5.43941L4.24469 3.18403C3.95179 2.89113 3.47692 2.89113 3.18403 3.18403C2.89113 3.47692 2.89113 3.95179 3.18403 4.24469L5.43941 6.50007L3.18403 8.75546C2.89113 9.04836 2.89113 9.52323 3.18403 9.81612C3.47692 10.109 3.95179 10.109 4.24469 9.81612L6.50007 7.56074L8.75546 9.81612C9.04836 10.109 9.52323 10.109 9.81612 9.81612C10.109 9.52323 10.109 9.04836 9.81612 8.75546L7.56074 6.50007L9.81612 4.24469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilterIc);
export default __webpack_public_path__ + "static/media/close_filter_ic.a06a7b619081ef10e6ba1295ba26e2ae.svg";
export { ForwardRef as ReactComponent };